module.exports = __webpack_public_path__ + "img/zuzi.3a1b4207.png";